"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchEventsApi = fetchEventsApi;
exports.fetchEventsSaga = fetchEventsSaga;
exports.fetchEventSaga = fetchEventSaga;
exports.loadEventsBy = loadEventsBy;
exports.fetchLinkedEventsSaga = fetchLinkedEventsSaga;
exports.fetchLinkedEvents = fetchLinkedEvents;
exports.fetchLinkedEventsAndComputeProbabilitiesSaga = fetchLinkedEventsAndComputeProbabilitiesSaga;
exports.fetchLinkedEventsAndComputeProbabilities = fetchLinkedEventsAndComputeProbabilities;
exports.fetchScheduledLiveEventsSaga = fetchScheduledLiveEventsSaga;
exports.fetchEventStatisticsSaga = fetchEventStatisticsSaga;
exports.fetchFavouritesEventsSaga = fetchFavouritesEventsSaga;
exports.fetchFavouritesEventsByIdsSaga = fetchFavouritesEventsByIdsSaga;
exports.fetchTopLineLiveEventsSaga = fetchTopLineLiveEventsSaga;
exports.fetchEventsWithoutSideEffectsSaga = fetchEventsWithoutSideEffectsSaga;
const effects_1 = require("redux-saga/effects");
const selectors_1 = require("../../CommonDataProvider/selectors");
const saga_1 = require("../../ConfigProvider/saga");
const selectors_2 = require("../../LanguagesProvider/selectors");
const saga_2 = require("../../LogosProvider/saga");
const headers_1 = require("../../../utils/api/headers");
const types_1 = require("../../ConfigProvider/types");
const types_2 = require("../../../utils/api/types");
const selectors_3 = require("../../FavouritesProvider/selectors");
const saga_3 = require("../../FavouritesProvider/saga");
const linkedEvents_1 = require("../../../utils/events/linkedEvents");
const errors_1 = require("../../../utils/errors");
const api_1 = require("../../../api/events/api");
const slice_1 = require("../slice");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
const eventProcessingSaga_1 = require("./eventProcessingSaga");
function* fetchEventsApi(reqPayload) {
    const request = { ...reqPayload };
    const newEventsEndpointEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.NEW_EVENTS_ENDPOINT);
    if (newEventsEndpointEnabled && reqPayload.ids === undefined) {
        request.pageSize = (0, utils_1.limitPageSize)(request.pageSize).pageSize;
    }
    if (newEventsEndpointEnabled) {
        const response = yield (0, effects_1.call)(api_1.getEventsV2, request);
        return { resData: response.data, headers: response.headers };
    }
    const response = yield (0, effects_1.call)(api_1.getEvents, request);
    return { resData: response.data, headers: response.headers };
}
function* fetchEventsSaga(action) {
    const { reqData, sideEffects: { onSuccess, onError } = {}, params = constants_1.defaultParams, } = action.payload;
    try {
        const locale = yield (0, effects_1.select)(selectors_2.selectCurrentLangCode);
        const topTagId = yield (0, effects_1.select)(selectors_1.selectTopTagId);
        const request = yield (0, effects_1.call)(utils_1.createGetEventsRequest, reqData, locale, topTagId, params);
        const { resData, headers } = yield (0, effects_1.call)(fetchEventsApi, request);
        yield (0, effects_1.put)(slice_1.eventsProviderActions.fetchEventsSuccess({ resData }));
        if (onSuccess) {
            yield (0, effects_1.put)(onSuccess({ reqData, resData, responseInfo: { headers } }));
        }
        if (resData.items.length > 0 && (params === null || params === void 0 ? void 0 : params.withCompetitorsLogo)) {
            yield (0, effects_1.fork)(saga_2.processLogosCompetitorsSaga, { events: resData.items });
        }
        // Linked events
        const linkedEventsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.LINKED_EVENTS_ENABLED);
        if (linkedEventsEnabled && params.withLinkedEvents) {
            yield (0, effects_1.fork)(fetchLinkedEvents, resData.items);
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching events', error);
        yield (0, effects_1.put)(slice_1.eventsProviderActions.fetchEventsError(error));
        if (onError) {
            yield (0, effects_1.put)(onError(error));
        }
    }
}
function* fetchEventSaga(action) {
    const { reqData, sideEffects: { onSuccess, onError } = {}, params = constants_1.defaultParams, } = action.payload;
    try {
        const { eventId } = reqData;
        const locale = yield (0, effects_1.select)(selectors_2.selectCurrentLangCode);
        const request = {
            ...reqData,
            locale,
        };
        const { data: event, headers } = yield (0, effects_1.call)(api_1.getEvent, request);
        const newOutcomesEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.NEW_OUTCOMES_ENABLED);
        if (newOutcomesEnabled) {
            yield (0, effects_1.call)(eventProcessingSaga_1.eventLoadedSideEffectV3, event);
        }
        else {
            const isComputeProbsOptimizationEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.COMPUTE_PROBS_OPTIMIZATION);
            if (isComputeProbsOptimizationEnabled) {
                yield (0, effects_1.call)(eventProcessingSaga_1.eventLoadedSideEffectV2, event);
            }
            else {
                yield (0, effects_1.call)(eventProcessingSaga_1.eventLoadedSideEffect, event);
            }
        }
        yield (0, effects_1.put)(slice_1.eventsProviderActions.fetchEventSuccess({ resData: event }));
        if (onSuccess) {
            const resData = {
                ...event,
                eventId,
            };
            if (reqData.withCursor) {
                resData.cursor = (0, headers_1.getHeadersFetch)(headers, 'x-cursor', false);
            }
            yield (0, effects_1.put)(onSuccess({
                reqData,
                resData,
            }));
        }
        if (params === null || params === void 0 ? void 0 : params.withCompetitorsLogo) {
            yield (0, effects_1.fork)(saga_2.processLogosCompetitorsSaga, {
                events: [event],
            });
        }
        // Linked events
        const linkedEventsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.LINKED_EVENTS_ENABLED);
        if (linkedEventsEnabled && params.withLinkedEvents) {
            yield (0, effects_1.fork)(fetchLinkedEventsAndComputeProbabilities, event);
        }
    }
    catch (e) {
        const { eventId } = reqData;
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching event', error);
        yield (0, effects_1.put)(slice_1.eventsProviderActions.fetchEventError({ error, eventId }));
        // TODO unify error type and try to send only one argument, because PayloadAction<T> wait only one parameter
        // example yield put(onError({e, payload }))
        // after that remove action below "eventsProviderActions.setStatusEventProbabilitiesSSE"
        if (onError) {
            yield (0, effects_1.put)(onError(error));
        }
        yield (0, effects_1.put)(slice_1.eventsProviderActions.setStatusEventProbabilitiesSSE({
            eventId,
            type: types_2.EEventMessageSSEType.ERROR,
        }));
    }
}
function* loadEventsBy(ids) {
    if (ids.length === 0)
        return [];
    const currentLangCode = yield (0, effects_1.select)(selectors_2.selectCurrentLangCode);
    const reqPayload = {
        ids,
        locale: currentLangCode,
    };
    const { resData } = yield (0, effects_1.call)(fetchEventsApi, reqPayload);
    return resData.items;
}
function* fetchLinkedEventsSaga(action) {
    yield (0, effects_1.call)(fetchLinkedEvents, action.payload.events);
}
function* fetchLinkedEvents(events) {
    try {
        const ids = (0, linkedEvents_1.getLinkedEventsIds)(events);
        if (!ids.length) {
            return;
        }
        const currentLangCode = yield (0, effects_1.select)(selectors_2.selectCurrentLangCode);
        const reqPayload = {
            ids,
            locale: currentLangCode,
        };
        const { resData } = yield (0, effects_1.call)(fetchEventsApi, reqPayload);
        yield (0, effects_1.put)(slice_1.eventsProviderActions.eventsLoaded({ resData }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching linked events', error);
    }
}
function* fetchLinkedEventsAndComputeProbabilitiesSaga(action) {
    yield (0, effects_1.call)(fetchLinkedEventsAndComputeProbabilities, action.payload.event);
}
function* fetchLinkedEventsAndComputeProbabilities(event) {
    const ids = (0, linkedEvents_1.getLinkedEventsIds)([event]);
    const events = yield (0, effects_1.call)(loadEventsBy, ids);
    for (let i = 0; i < events.length; i += 1) {
        const event = events[i];
        yield (0, effects_1.call)(eventProcessingSaga_1.eventLoadedSideEffect, event);
    }
}
function* fetchScheduledLiveEventsSaga(action) {
    const { reqData, sideEffects: { onSuccess, onError } = {}, params = constants_1.defaultParams, } = action.payload;
    try {
        const currentLangCode = yield (0, effects_1.select)(selectors_2.selectCurrentLangCode);
        const reqPayload = { ...reqData, locale: currentLangCode };
        // TODO:OL-867 Remove after release
        const isGenericEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.GENERIC_SPORT_ENABLED);
        if (reqData.sportId && params.includeSubsports && isGenericEnabled) {
            const childrenSportIds = yield (0, effects_1.select)((s) => (0, selectors_1.selectChildrenSportIds)(s, reqData.sportId));
            if (childrenSportIds.length) {
                reqPayload.sportId = undefined;
                reqPayload.sportIds = childrenSportIds;
            }
        }
        const { data: resData } = yield (0, effects_1.call)(api_1.getScheduledLiveEvents, reqPayload);
        yield (0, effects_1.put)(slice_1.eventsProviderActions.fetchScheduledLiveEventsSuccess({ resData }));
        if (onSuccess) {
            yield (0, effects_1.put)(onSuccess({ reqData, resData }));
        }
        // Linked events
        const linkedEventsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.LINKED_EVENTS_ENABLED);
        if (linkedEventsEnabled && params.withLinkedEvents) {
            yield (0, effects_1.fork)(fetchLinkedEvents, resData.items);
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching scheduled live events', error);
        yield (0, effects_1.put)(slice_1.eventsProviderActions.fetchScheduledLiveEventsError(error));
        if (onError) {
            yield (0, effects_1.put)(onError(error));
        }
    }
}
function* fetchEventStatisticsSaga(action) {
    try {
        const { data } = yield (0, effects_1.call)(api_1.getEventStatistics, action.payload);
        yield (0, effects_1.put)(slice_1.eventsProviderActions.fetchEventStatisticsSuccess(data));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching event statistics', error);
        yield (0, effects_1.put)(slice_1.eventsProviderActions.fetchEventStatisticsError(error));
    }
}
function* fetchFavouritesEventsSaga(payload) {
    // To fetch events by favourite events ids
    try {
        const eventsIds = yield (0, effects_1.select)(selectors_3.selectFavouriteEventsIds);
        if (eventsIds.length) {
            const currentLangCode = yield (0, effects_1.select)(selectors_2.selectCurrentLangCode);
            const reqPayload = {
                ids: eventsIds,
                locale: currentLangCode,
            };
            // If there are any favourites events
            const { resData } = yield (0, effects_1.call)(fetchEventsApi, reqPayload);
            yield (0, effects_1.put)(slice_1.eventsProviderActions.fetchEventsSuccess({ resData }));
            const linkedEventsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.LINKED_EVENTS_ENABLED);
            if (linkedEventsEnabled && (payload === null || payload === void 0 ? void 0 : payload.withLinkedEvents)) {
                yield (0, effects_1.fork)(fetchLinkedEvents, resData.items);
            }
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching favourite events', error);
        yield (0, effects_1.put)(slice_1.eventsProviderActions.fetchEventsError(error));
    }
}
function* fetchFavouritesEventsByIdsSaga(action) {
    try {
        yield (0, effects_1.call)(saga_3.fetchFavouriteEventsIdsSaga);
        yield (0, effects_1.call)(fetchFavouritesEventsSaga, action === null || action === void 0 ? void 0 : action.payload);
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error in fetchFavouritesEventsByIdsSaga:', error);
    }
}
function* fetchTopLineLiveEventsSaga() {
    try {
        yield (0, effects_1.spawn)(fetchEventsWithoutSideEffectsSaga, (0, constants_1.getParamsFetchTopLiveEvents)({ withCursor: true }));
        yield (0, effects_1.spawn)(fetchEventsWithoutSideEffectsSaga, (0, constants_1.getParamsFetchTopLiveEvents)({ live: false, withCursor: true }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('fetchTopLineLiveEventsSaga error', error);
    }
}
function* fetchEventsWithoutSideEffectsSaga(action) {
    const { reqData } = action;
    try {
        const locale = yield (0, effects_1.select)(selectors_2.selectCurrentLangCode);
        const request = {
            ...reqData,
            locale,
        };
        const { resData, headers } = yield (0, effects_1.call)(fetchEventsApi, request);
        if (reqData.withCursor) {
            const newCursor = (0, headers_1.getHeadersFetch)(headers, 'x-cursor', false);
            yield (0, effects_1.put)(slice_1.eventsProviderActions.setCursorTopEvents({ cursor: newCursor }));
        }
        yield (0, effects_1.put)(slice_1.eventsProviderActions.fetchEventsSuccess({ resData }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching events', error);
        yield (0, effects_1.put)(slice_1.eventsProviderActions.fetchEventsError(error));
    }
}
/*
  For not for force computeEventProbabilitiesByMarketSaga each time we uplaod same event
*/
//# sourceMappingURL=fetchEventsSaga.js.map